import * as types from '../constants/actionTypes';

export function clearVersionError({status, data} = {}) {
    return { type: types.CLEAR_VERSION_ERROR, status, data };
}
export function loadVersion({status, data} = {}) {
    return { type: types.LOAD_VERSION, status, data };
}



/** WEBPACK FOOTER **
 ** ./src/app/constants/tashiActions.js
 **/